module.exports = __webpack_public_path__ + "img/交易@2x.02a0bb4e.png";